import axios from "../../Axios";
import { Urls } from "../../Urls";
import { useMutation, useQuery } from "@tanstack/react-query";

export const calculateNegotiationRates = async (truck_enquiry_id, force = false) => {
  const res = await axios.post(
    Urls.calculateNegotiationRates(truck_enquiry_id, force)
  );
  return res.data;
};

export const useCalculateNegotiationRates = (truck_enquiry_id, options = {}) => {
  return useQuery({
    queryKey: ["calculateNegotiationRates", truck_enquiry_id],
    queryFn: () => calculateNegotiationRates(truck_enquiry_id, false),
    enabled: !!truck_enquiry_id && options.enabled !== false,
    staleTime: 60 * 1000,
    retry: false,
  });
};

export const setupNegotiationAgent = async (spotNegotiationList) => {
  const url = `${Urls.setupNegotiationAgent}/rates`
  const res = await axios.post(url, {
    spot_negotiation: spotNegotiationList,
  });
  return res.data;
};

export const useSetupNegotiationAgent = () => {
  return useMutation({
    mutationFn: (spotNegotiationList) => setupNegotiationAgent(spotNegotiationList),
  });
};

export const getNegotiationAgentSettings = async (truck_enquiry_id, get_child_docs = true) => {
  const res = await axios.get(
    Urls.getNegotiationAgentSettings(truck_enquiry_id, get_child_docs)
  );
  return res.data;
};

export const getNegotiationStatus = async (truck_enquiry_id) => {
  const res = await axios.get(Urls.getNegotiationStatus(truck_enquiry_id));
  return res.data;
};
